import React from "react";
import { useState } from 'react';

const state = {
    show: false,
    value: "",
    isLoading: false,
    initValue: null,
    onClose: () => { },
    onConfirmation: () => { },
    configuration: {
        title: ""
    }
}

export default function useGenericFormModal({ ModalComponent = ({ state }) => (<></>) }) {
    const [modalState, setModalState] = useState(state);

    const _close = () => setModalState({ ...state, configuration: { title: "" }, show: false, isLoading: false });

    const actions = {
        Show: ({ title = "", onConfirmation = () => { }, initValue = null } = {}) => {
            setModalState({
                ...state, show: true, configuration: { title }, initValue, onConfirmation: async (submitData) => {
                    setModalState({ ...state, isLoading: true })
                    await onConfirmation(submitData)
                    setModalState({ ...state, isLoading: false })
                }
            })
        },
        Close: () => _close()
    }
    const modal = () => modalState.show == true
        ? (<ModalComponent state={{ ...modalState, onClose: () => _close() }} > </ModalComponent>)
        : null

    return [modal, actions]
};